import React from "react";
import { ContainerProps } from "@mui/material";
import { StyledContainer } from "./styles";

export function SectionContainer(props: ContainerProps): React.ReactElement {
  return <StyledContainer {...props} />;
}
